import moment from 'moment'
import { formatarOS } from '@/common/helpers/StringHelper'
import { CTRL_MODULOS } from '@/common/boot/Constantes'

export function ticketParaWorkflow(ticket, moduloAtivo) {
  if (!ticket?.pco_workflow) return ticket

  const { pco_workflow: workflow, ...provedor } = ticket
  const tratamentos = workflow.pco_tratamento || []
  const chaveProvedor = moduloAtivo == CTRL_MODULOS.INSTALACAO
    ? 'provedor_instalacao'
    : 'provedor_recuperacao'

  return {
    ...workflow,
    ultimo_tratamento: workflow.ultimo_tratamento ?? tratamentos[tratamentos.length - 1] ?? null,
    [chaveProvedor]: provedor,
  }
}

export function normalizarWorkflow(item) {
  const tipo = item.provedor_recuperacao ? 'recuperacao'
             : item.provedor_instalacao  ? 'instalacao'
             : 'outro'

  const rec  = item.provedor_recuperacao || {}
  const inst = item.provedor_instalacao  || {}
  const provedor = rec.provedor || inst.provedor || {}

  const ultimaTarefa = item.tarefas?.find(t => !t.finalized_at)
    ?? item.tarefas?.[item.tarefas.length - 1]

  return {
    ...item,
    _tipo: tipo,
    redirecionar: ultimaTarefa?.id ? `/workflow/ficha-tecnica-tarefa/${ultimaTarefa.id}` : null,
    possuiTarefaVinculada: item.tarefas?.length > 0,

    // shared
    workflow_nome:        item.ctrl_workflow?.workflow || '—',
    etapa_atual:          item.ultima_tarefa?.ctrl_tarefa
      ? [item.ultima_tarefa.ctrl_tarefa.map, item.ultima_tarefa.ctrl_tarefa.tarefa].filter(Boolean).join(' - ')
      : '—',
    finalized_at:         item.finalized_at ? moment(item.finalized_at).format('DD/MM/YYYY HH:mm') : '—',
    ultima_atualizacao:   item.ultimo_tratamento?.updated_at
      ? moment(item.ultimo_tratamento.updated_at).format('DD/MM/YYYY HH:mm') : '—',
    provedor_nome:        provedor.nome || '—',
    provedor_uf:          provedor.uf   || '—',
    provedor_responsavel: provedor.responsavel || '—',

    // recuperacao
    numero_rec:               rec.numero_rec        || '—',
    centro_funcional:         rec.centro_funcional  || null,
    cliente_final:            rec.cliente_final     || '—',
    descricao_problema:       rec.descricao_problema || '—',
    designacao:               rec.designacao?.designacao || '—',
    designacao_provedor:      rec.identificacao_acesso_provedor || '—',
    data_abertura_ticket:     rec.data_abertura_ticket
      ? moment(rec.data_abertura_ticket, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm') : '—',
    data_atendimento_cliente: rec.data_atendimento_cliente
      ? moment(rec.data_atendimento_cliente).format('DD/MM/YYYY') : '—',
    os:                       formatarOS(item.id) || '—',

    // instalacao
    regional_inst:   inst.ctrl_regional?.regional             || '—',
    tipo_servico:    inst.tipo_servico?.nome    || '—',
    tipo_solicitacao:inst.tipo_solicitacao?.nome|| '—',
    cod_circuito:    inst.cod_circuito          || '—',
  }
}
